<script setup lang="ts">
const props = defineProps<{
  employee?: object
}>()

const fullName = computed(() => `${props.employee?.first_name} ${props.employee?.last_name}`)
</script>

<template>
  <figure class="relative  w-full gap-3 rounded-lg border bg-white p-3">
    <img
      class="h-[360px] w-full rounded-md object-cover"
      :src="useImageProxy(employee?.image, 600, 600)"
      alt=""
    >
    <caption class="mt-2 flex w-full flex-col rounded-full text-left">
      <h3 class="font-bold">
        {{ fullName }}
      </h3>
      <div class="text-sm font-light">
        {{ employee.function }}
      </div>

      <hr
        v-if="employee.public_email || employee.public_phone"
        class="my-3"
      >

      <a
        v-if="employee.public_phone"
        class="flex items-center gap-2 text-sm"
        :href="`tel:${employee.public_phone}`"
      >
        <span class="i-mdi-phone" />
        {{ employee.public_phone }}
      </a>

      <a
        v-if="employee.public_email"
        class="flex items-center gap-2 text-sm"
        :href="`mailto:${employee.public_email}`"
      >
        <span class="i-mdi-email-outline" />
        {{ employee.public_email }}
      </a>
    </caption>
  </figure>
</template>
